import { gql } from '@apollo/client';

export const campaignFragment = gql`
  fragment campaignGoalStats on CampaignGoalStatsDefinition {
    id
    type
    name
    thumbnail
    messageMedium
    startedAt
    contributions
    revenue
    sends
    delivered
  }
`;

export const fetchPerformantCampaignsQuery = gql`
  ${campaignFragment}

  query fetchPerformantCampaigns(
    $goalName: String!
    $count: Int!
    $startTime: Instant!
    $endTime: Instant!
  ) {
    bestWorstCampaignStatsForGoal(
      goalName: $goalName
      count: $count
      startTime: $startTime
      endTime: $endTime
    ) {
      best {
        ...campaignGoalStats
      }
      worst {
        ...campaignGoalStats
      }
    }
  }
`;

export const fetchIfTimeRangeHasData = gql`
  query fetchPerformantCampaigns(
    $goalName: String!
    $count: Int!
    $startTime: Instant!
    $endTime: Instant!
  ) {
    bestWorstCampaignStatsForGoal(
      goalName: $goalName
      count: $count
      startTime: $startTime
      endTime: $endTime
    ) {
      best {
        id
        contributions
        sends
      }
    }
  }
`;

export const fetchCampaignContributionsQuery = gql`
  query fetchCampaignStatsForGoal(
    $goalName: String!
    $startTime: Instant!
    $endTime: Instant!
    $pagination: Pagination!
    $sort: Sort!
  ) {
    campaignStatsForGoal(
      goalName: $goalName
      startTime: $startTime
      endTime: $endTime
      pagination: $pagination
      sort: $sort
    ) {
      info {
        count
        offset
        limit
        page
      }
      results {
        id
        name
        type
        startedAt
        state
        sends
        delivered
        contributions
        uniqueContributions
        messageMedium
      }
      totalSends
    }
  }
`;
